import React from 'react';
import { observer } from 'mobx-react-lite';
import { Box, IconButton, Typography, Tooltip } from '@mui/material';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import FitScreenIcon from '@mui/icons-material/FitScreen';

const ZoomButtons = observer(({ store }) => {
  const zoomIn = () => {
    store.setScale(Math.min(5, store.scale * 1.2));
  };

  const zoomOut = () => {
    store.setScale(Math.max(0.1, store.scale / 1.2));
  };

  const zoomToFit = () => {
    store.setScale(store.scaleToFit);
  };

  const zoomPercentage = Math.round(store.scale * 100);

  return (
    <Box
      sx={{
        position: 'absolute',
        bottom: 12,
        right: 12,
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        backgroundColor: 'rgba(255,255,255,0.95)',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        padding: '4px 8px',
        zIndex: 10,
      }}
    >
      <Tooltip title="Zoom out">
        <IconButton size="small" onClick={zoomOut}>
          <ZoomOutIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <Typography
        variant="caption"
        sx={{
          minWidth: 40,
          textAlign: 'center',
          fontSize: '12px',
          fontWeight: 500,
          userSelect: 'none',
        }}
      >
        {zoomPercentage}%
      </Typography>

      <Tooltip title="Zoom in">
        <IconButton size="small" onClick={zoomIn}>
          <ZoomInIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <Tooltip title="Fit to screen">
        <IconButton size="small" onClick={zoomToFit}>
          <FitScreenIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
});

ZoomButtons.displayName = 'ZoomButtons';
export default ZoomButtons;
export { ZoomButtons };
